import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";

const reportFormFormat = (state) => state.reportForm.format;
const reportFormSchema = (state) => state.reportForm.schema;
const reportFormStructure = (state) => state.reportForm.structure;
const reportFormFormatDuration = (state) => state.reportForm.format.duration;
const reportFormEndpoint = (state) => state.reportForm.endpoint;
const reportFormSchedule = (state) => state.reportForm.schedule;

const FILENAME_FORMAT_REGEX = /\{(.+?)\}/g;

const DIMENSION_DISPLAY_ORDER = (dimension_name) => {
  switch (dimension_name.trim().toLowerCase()) {
    case "date":
      return 0;
    case "week":
      return 1;
    case "month":
      return 2;
    case "year":
      return 3;
    case "channel":
      return 4;
    case "device type":
      return 5;
    case "flyer type":
      return 6;
    case "flyer run name":
      return 7;
    case "flyer":
      return 8;
    case "country":
      return 9;
    case "province":
      return 10;
    case "city":
      return 11;
    case "dma":
      return 12;
    case "fsa":
      return 13;
    case "postal code":
      return 14;
    case "zip":
      return 15;
    case "ldu confidence":
      return 16;
    case "language":
      return 17;
    default:
      return 0;
  }
};

const METRIC_DISPLAY_ORDER = (metric_name) => {
  switch (metric_name.toLowerCase()) {
    case "unique engaged visits":
      return 0;
    case "impressions":
      return 1;
    case "opens":
      return 2;
    case "clicks":
      return 4;
    case "clippings":
      return 5;
    case "info button":
      return 6;
    case "add to cart":
      return 7;
    case "ttm":
      return 8;
    case "share email":
      return 9;
    case "share fb":
      return 10;
    case "share twitter":
      return 11;
    case "share pinterest":
      return 12;
    case "share google plus":
      return 13;
    case "share url":
      return 14;
    case "share sms":
      return 15;
    default:
      return 0;
  }
};

export const reportFormatPreviewStringSelector = createSelector(
  reportFormFormat,
  (format) => {
    let { filename, extension, compressed } = format;
    if (!filename) return "";
    // extract format blocks in filename
    let fn = filename;
    let formats = fn.match(FILENAME_FORMAT_REGEX);
    if (formats) {
      formats.forEach((match) => {
        // match returns full match, not captured group for global option
        let group = match.replace(/{|}/g, "");
        fn = fn.replace("{" + group + "}", moment().format(group));
      });
    }

    // construct base string
    let baseStr = fn;
    // append duration template
    baseStr += "_[startdate]_to_[enddate]";
    // check if filename already has extension
    if (extension !== "") baseStr += "." + extension;
    // check if compressed is true
    if (compressed === true) baseStr += ".gz";
    return baseStr;
  }
);

export const reportStructureSchemaSelector = createSelector(
  reportFormSchema,
  reportFormStructure,
  (schema, structure) => {
    let metric_display = schema.metrics.map((metric) => ({
      ...metric,
      display_order: METRIC_DISPLAY_ORDER(metric.name)
    }));
    let dimension_display = schema.dimensions.map((dimension) => ({
      ...dimension,
      display_order: DIMENSION_DISPLAY_ORDER(dimension.name)
    }));

    return {
      metrics: { schema: metric_display, selected: structure.metrics },
      dimensions: { schema: dimension_display, selected: structure.dimensions }
    };
  }
);

export const reportDurationStringSelector = createSelector(
  reportFormFormatDuration,
  (duration) => {
    switch (duration) {
      case "one_day":
        return "1 Day";
      case "one_week":
        return "1 Week";
      case "one_month":
        return "1 Month";
      case "three_months":
        return "3 Months";
      default:
        return "";
    }
  }
);

export const reportEndpointStringSelector = createSelector(
  reportFormEndpoint,
  (endpoint) => {
    return _.keys(_.pickBy(endpoint, (ep) => ep.checked))
      .map((endpoint_type) => {
        if (endpoint_type === "email") {
          return "Email";
        } else if (endpoint_type === "ftp") {
          return "FTP";
        } else if (endpoint_type === "sftp") {
          return "Secure FTP";
        } else {
          return "";
        }
      })
      .join(", ");
  }
);

const weekdays = [
  "Mondays",
  "Tuesdays",
  "Wednesdays",
  "Thursdays",
  "Fridays",
  "Saturadays",
  "Sundays"
];

export const reportScheduleStringSelector = createSelector(
  reportFormSchedule,
  (schedule) => {
    let str = _.startCase(schedule.type);
    if (schedule.type === "weekly") {
      str += " on " + weekdays[schedule.day - 1];
    } else if (schedule.type === "monthly") {
      str += " on day " + schedule.day;
    }
    return str;
  }
);



// WEBPACK FOOTER //
// ./client/modules/ReportForm/selectors.js